import {
    Box,
    BoxContent,
    PriceLevel,
    Text,
    TextLevels,
    TextMarkup,
    Title,
    TitleLevels,
    TitleMarkup,
    TrilogyColor,
    TypographyAlign,
} from '@bytel/trilogy-react';

import { PRICE_TYPE } from '@app-types/price';

import { BoxInfo } from '@components/box-info';
import { ListItemWithPrice } from '@components/list-item-with-price';

import { useApp } from '@hooks/use-app';
import { useCart } from '@hooks/use-cart';

import { livraisonRoute } from '@helpers/routes';

import { PrintAddress } from '../common/print-address';

type CartDefferedProps = {
    isFromCart: boolean;
};

export default function CartDeffered({ isFromCart }: Readonly<CartDefferedProps>) {
    const { goTo } = useApp();
    const { byouCart: cart } = useCart();
    const isSim = !cart?.sim?.esim;

    if (!cart) {
        return null;
    }

    const getAmount = () => {
        let amount = 0;
        if (cart.sim?.priceType === PRICE_TYPE.DEFERRED) {
            amount += cart.sim.price;
        }

        if (cart.mobileFees?.prices.type === PRICE_TYPE.DEFERRED) {
            amount += cart.mobileFees.price;
        }

        if (cart.deliveryMode?.priceType === PRICE_TYPE.DEFERRED) {
            amount += cart.deliveryMode.price;
        }

        return amount;
    };

    const getHeader = () => {
        return (
            <ListItemWithPrice
                mainTitle='À régler sur la 1ère facture'
                amount={getAmount()}
                id='SummaryDefferedBox'
                className='has-text-white'
                priceLevel={PriceLevel.FIVE}
            />
        );
    };

    return (
        <BoxInfo header={getHeader()}>
            {isFromCart ? (
                <>
                    <Title level={TitleLevels.FIVE} markup={TitleMarkup.H3}>
                        {cart.mobileFees?.name}
                    </Title>
                    <ListItemWithPrice
                        subTitle='Mise en service et configuration de votre nouvelle ligne.'
                        amount={cart?.mobileFees?.price || 0}
                        id='SummaryDefferedBoxProducts'
                    />
                </>
            ) : (
                <>
                    <Text marginless level={TextLevels.TWO} typo={TypographyAlign.TEXT_CENTERED}>
                        Commandez aujourd’hui !<br /> Payez sur votre première facture
                    </Text>
                    {cart.deliveryMode && cart.deliveryMode.priceType === PRICE_TYPE.DEFERRED && (
                        <Box shadowless>
                            <BoxContent backgroundColor={TrilogyColor.INFO_FADE}>
                                <Title level={TitleLevels.FIVE}>
                                    {isSim ? 'Livraison de votre carte sim' : 'eSIM'}
                                </Title>
                                {isSim &&
                                    (cart.address ? (
                                        <PrintAddress address={cart.address} />
                                    ) : (
                                        <div>Adresse manquante</div>
                                    ))}
                                <Text markup={TextMarkup.SPAN}>
                                    {!isSim && 'eSIM accessible depuis votre application Bouygues Telecom'}
                                    {isSim && (
                                        <button
                                            className='link button-clear'
                                            onClick={() => goTo(livraisonRoute.path)}
                                            aria-label='Modifer mon adresse de livraison'
                                            type='button'
                                        >
                                            Modifier mon adresse de livraison
                                        </button>
                                    )}
                                </Text>
                            </BoxContent>
                        </Box>
                    )}
                </>
            )}
        </BoxInfo>
    );
}
